module.exports = __webpack_public_path__ + "img/mail_envoi_carte_tp.4ec5f4e5.svg";